// extracted by mini-css-extract-plugin
export default {"type":"home_type__Cqq4T","b":"home_b__Z76u7","t":"home_t__0VGFd"};